import { render } from "./ModalContant.vue?vue&type=template&id=635b2d6a"
import script from "./ModalContant.vue?vue&type=script&lang=js"
export * from "./ModalContant.vue?vue&type=script&lang=js"

import "./ModalContant.vue?vue&type=style&index=0&id=635b2d6a&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__